export function createEmptyChapter() {
  return { title: '', duration: '', videoUrl: '', description: '' }
}

export function createEmptyFaq() {
  return { question: '', answer: '' }
}

export function parseChaptersJson(json) {
  if (!json) return []
  try {
    const list = typeof json === 'string' ? JSON.parse(json) : json
    return Array.isArray(list)
      ? list.map(item => ({
          title: item.title || '',
          duration: item.duration || '',
          videoUrl: item.videoUrl || '',
          description: item.description || ''
        }))
      : []
  } catch (e) {
    return []
  }
}

export function parseFaqsJson(json) {
  if (!json) return []
  try {
    const list = typeof json === 'string' ? JSON.parse(json) : json
    return Array.isArray(list)
      ? list.map(item => ({
          question: item.question || '',
          answer: item.answer || ''
        }))
      : []
  } catch (e) {
    return []
  }
}

export function serializeChapters(chapters) {
  const list = (chapters || [])
    .filter(ch => ch.title || ch.duration || ch.videoUrl || ch.description)
    .map(ch => ({
      title: (ch.title || '').trim(),
      duration: (ch.duration || '').trim(),
      videoUrl: ch.videoUrl || '',
      description: (ch.description || '').trim()
    }))
  return JSON.stringify(list)
}

export function serializeFaqs(faqs) {
  const list = (faqs || [])
    .filter(f => f.question || f.answer)
    .map(f => ({
      question: (f.question || '').trim(),
      answer: (f.answer || '').trim()
    }))
  return JSON.stringify(list)
}

export function defaultTutorialForm(extra = {}) {
  return {
    instructorName: '',
    instructorAvatar: '',
    instructorTitle: '',
    instructorIntro: '',
    targetAudience: '',
    learningGoals: '',
    chapters: [],
    faqs: [],
    ...extra
  }
}
